import { render } from "./teaTeamLessonInfo.vue?vue&type=template&id=25884020&scoped=true"
import script from "./teaTeamLessonInfo.vue?vue&type=script&lang=js"
export * from "./teaTeamLessonInfo.vue?vue&type=script&lang=js"

import "./teaTeamLessonInfo.vue?vue&type=style&index=0&id=25884020&scoped=true&lang=css"
import "./teaTeamLessonInfo.vue?vue&type=style&index=1&id=25884020&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25884020"]])

export default __exports__